import React from 'react';

export const Footer: React.FC = () => (
  <footer style={{
    height: '53px',
    background: 'var(--surface)',
    borderTop: '1px solid var(--border)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 24px',
    flexShrink: 0,
  }}>
    <span style={{ fontSize: '12px', color: 'var(--text-3)' }}>
      © 2025 Salam Telecom. All rights reserved.
    </span>
    <div style={{ display: 'flex', gap: '16px' }}>
      {['Privacy Policy', 'Terms of Use', 'Support'].map((link) => (
        <a
          key={link}
          href="#"
          style={{ fontSize: '12px', color: 'var(--text-2)', textDecoration: 'none' }}
          onMouseEnter={(e) => { (e.currentTarget as HTMLElement).style.color = 'var(--p)'; }}
          onMouseLeave={(e) => { (e.currentTarget as HTMLElement).style.color = 'var(--text-2)'; }}
        >
          {link}
        </a>
      ))}
    </div>
  </footer>
);
